import React from 'react'
import { string, object, array, bool } from 'prop-types'
import Advert from '@/component/Primitive/Advert'

const AdvertWidget = ({
  slotName,
  size,
  suffix,
  background,
  keyValueTargeting: widgetKeyValueTargeting,
  alignment,
  section,
  article,
  pageData
}) => {
  const { disableAds } = pageData
  if (disableAds) return null

  const setArticleIdAsKeyValuePair = section.setArticleIdAsKeyValuePair
  const sectionKeyValueTargeting = (section && section.keyValueTargeting) || []
  let keyValueTargeting = []
  if (sectionKeyValueTargeting && widgetKeyValueTargeting) {
    keyValueTargeting = [
      ...sectionKeyValueTargeting,
      ...widgetKeyValueTargeting
    ]
  }

  if (setArticleIdAsKeyValuePair && section.articleIdKeyToSet) {
    const key = section.articleIdKeyToSet
    const value = article.migratedFromId || article._id
    keyValueTargeting.push({ key, value })
  }

  return (
    <Advert
      slotName={slotName}
      size={size}
      suffix={suffix}
      keyValueTargeting={keyValueTargeting}
      alignment={alignment}
      section={section}
      article={article}
      hasBackground={background}
      pageData={pageData}
    />
  )
}

AdvertWidget.propTypes = {
  slotName: string,
  size: string,
  suffix: string,
  keyValueTargeting: array,
  alignment: string,
  section: object,
  article: object,
  background: bool,
  pageData: object
}

export default AdvertWidget
